import { APICore, INSURANCE_URL } from './apiCore';

const api = new APICore();

export interface Occupation {
    _id: string;
    name: string;
    multiplier: number;
    company: {
        _id: string;
        name: string;
        shortName?: string;
    } | string;
    createdAt?: string;
    updatedAt?: string;
}

export interface GetOccupationsParams {
    company?: string;
    name?: string;
    limit?: number;
    page?: number;
}

export interface GetOccupationsResponse {
    occupations: Occupation[];
    total: number;
}

const getOccupations = (params?: GetOccupationsParams): Promise<GetOccupationsResponse> => {
    const url = `${INSURANCE_URL}/occupations`;
    return api.get(url, params);
};

const createOccupation = (params: { name: string; multiplier?: number; company: string }): Promise<{ occupation: Occupation }> => {
    return api.create(`${INSURANCE_URL}/occupations`, params);
};

const updateOccupation = (occupationId: string, params: { name?: string; multiplier?: number; company?: string }): Promise<{ occupation: Occupation }> => {
    return api.update(`${INSURANCE_URL}/occupations/${occupationId}`, params);
};

const deleteOccupation = (occupationId: string): Promise<{ success: boolean }> => {
    return api.delete(`${INSURANCE_URL}/occupations/${occupationId}`);
};

const importOccupationsFromCSV = async (file: File): Promise<{
    success: boolean;
    created: number;
    updated: number;
    deleted: number;
    total: number;
    byCompany: Record<string, number>;
    errors?: Array<{ line: number; message: string }>;
}> => {
    const formData = new FormData();
    formData.append('file', file);
    return api.createWithFile(`${INSURANCE_URL}/occupations/import`, { file });
};

export { getOccupations, createOccupation, updateOccupation, deleteOccupation, importOccupationsFromCSV };
